import gpxParser from "gpxparser";

export async function getGpxCoordinates(url: string) {
  const response = await fetch(url);
  const xmlString = await response.text();

  // Cast the imported class instance to 'any' right as we create it
  const gpx = new (gpxParser as any)();
  gpx.parse(xmlString);
  return gpx.toGeoJSON();
}
